/**
 * Coerce an API id-list field into a string[].
 *
 * Post payloads don't always honor the declared `string[]` shape for fields like
 * `tag_list` / `travel_with_types`: public share payloads send a comma-separated
 * or JSON-array string, arrays can hold `{ id }` objects, and other non-array
 * values have been observed. Anything unrecognized becomes `[]`.
 */
export function coerceStringIdArray(raw: unknown): string[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .flatMap((item) => {
        if (typeof item === 'string') {
          const t = item.trim();
          return t ? [t] : [];
        }
        if (item && typeof item === 'object' && 'id' in item) {
          const id = (item as { id: unknown }).id;
          if (typeof id === 'string' && id.trim()) return [id.trim()];
        }
        return [];
      })
      .filter(Boolean);
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t) return [];
    if (t.startsWith('[')) {
      try {
        return coerceStringIdArray(JSON.parse(t) as unknown);
      } catch {
        /* fall through to CSV / single token */
      }
    }
    return t
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}
